import { Logger, ConfigService, type FeatureFlag } from '@nextgen-web-framework/core';
import logObject from './logObject';
import { FeatureFlagProvider } from '@nextgen-web-framework/all';
import { useEffect } from 'react';

const logger = Logger.getInstance(logObject('withFeatureFlags.tsx'));

export interface FeatureFlagEnabledPage {
  featureFlags: FeatureFlag;
}

function withFeatureFlags<T>(OriginalPageComponent: (props: T) => JSX.Element): any {
  const configs = ConfigService.getConfigs();

  logger.debug('NEXT_PUBLIC_FEATURE_FLAG', configs.NEXT_PUBLIC_FEATURE_FLAG);

  const PageWithFeatureFlags = (props: T & FeatureFlagEnabledPage) => {
    useEffect(() => {
      logger.log(`feature flag values on page: ${JSON.stringify(props?.featureFlags)}`);
    }, []);

    return (
      <FeatureFlagProvider featureFlagData={props?.featureFlags}>
        <OriginalPageComponent {...props} />
      </FeatureFlagProvider>
    );
  };
  return PageWithFeatureFlags;
}

export default withFeatureFlags;
